module.exports = __webpack_public_path__ + "media/images/category/feature/coj_d/og-coj_d-99fcf089cff9df6ba7551ac7f7534309.png";